function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#31CBE2",
  d: "M15.515 0l-.264.264-2.38 2.38-.265.265.264.265 2.38 2.38.265.264.264-.264 2.38-2.38.265-.265-.264-.264-2.38-2.38z"
}), React.createElement("path", {
  fill: "#D7E1E2",
  d: "M9.535 6.084L.26 15.52l-.26.266.261.266 15.413 15.682.26.266.262-.266L31.739 15.92l.261-.266-.261-.266-8.882-9.037-.261-.266-.261.266-8.62 8.771-.262.266.261.266 2.351 2.392.262.266.26-.266 6.009-6.113 3.657 3.721-10.318 10.5L5.747 15.785l6.661-6.778.261-.266-.26-.266-2.352-2.392-.26-.266z"
}));

var SvgIgFooterLogo = function SvgIgFooterLogo(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjMzFDQkUyIiBkPSJNMTUuNTE1IDBsLS4yNjQuMjY0LTIuMzggMi4zOC0uMjY1LjI2NS4yNjQuMjY1IDIuMzggMi4zOC4yNjUuMjY0LjI2NC0uMjY0IDIuMzgtMi4zOC4yNjUtLjI2NS0uMjY0LS4yNjQtMi4zOC0yLjM4eiIvPjxwYXRoIGZpbGw9IiNEN0UxRTIiIGQ9Ik05LjUzNSA2LjA4NEwuMjYgMTUuNTIgMCAxNS43ODZsLjI2MS4yNjYgMTUuNDEzIDE1LjY4Mi4yNi4yNjYuMjYyLS4yNjZMMzEuNzM5IDE1LjkybC4yNjEtLjI2Ni0uMjYxLS4yNjYtOC44ODItOS4wMzctLjI2MS0uMjY2LS4yNjEuMjY2LTguNjIgOC43NzEtLjI2Mi4yNjYuMjYxLjI2NiAyLjM1MSAyLjM5Mi4yNjIuMjY2LjI2LS4yNjYgNi4wMDktNi4xMTMgMy42NTcgMy43MjEtMTAuMzE4IDEwLjVMNS43NDcgMTUuNzg1bDYuNjYxLTYuNzc4LjI2MS0uMjY2LS4yNi0uMjY2LTIuMzUyLTIuMzkyLS4yNi0uMjY2eiIvPjwvZz48L3N2Zz4=";
export { SvgIgFooterLogo as ReactComponent };